/// <reference types="react-scripts" />
import * as React from "react";
import * as taskService from "source/models/services/taskService";
import { ISessionState } from "source/models/session/sessionState";
import { AppUtils } from "source/framework/appUtils";
import { useEffect } from "react";
import { DashboardStatistics } from "source/components/framework/DashboardStatistics";
import { IFrontToDoItems } from "source/models/front/frontToDoItems";
import { TaskPagePanel, TaskStatisticsPanelId } from "source/models/task";
import { setTaskListDefaultFilter, setTaskReportDefaultFilter } from "source/models/store/task";
import { customHistory } from "source/framework/customHistory";
import { IFrontToDoItem } from "source/models/front/frontToDoItem";
import { TaskPage } from "source/components/task/TaskPage";

export interface IFrontTaskPanelProp {
    sessionState: ISessionState;
    companyId: string;
    id: string;
}

export interface FrontTaskPanelState {
    isLoading: boolean;
    toDoItems: IFrontToDoItems;
}

const handleFrontTaskPanelToDoItemClick = (item: IFrontToDoItem, sessionState: ISessionState) => {
    if (!item) return;
    const defaultReportFilter = TaskPage.getDefaultSavedReportFilter(item);
    if (defaultReportFilter) {
        setTaskReportDefaultFilter(defaultReportFilter);
        customHistory.push("/new/task/reports");
        return;
    }
    setTaskListDefaultFilter(TaskPage.getDefaultListFilter(item, sessionState?.code ?? ""));
    customHistory.push("/new/task/list");
};

export const FrontTaskPanel = (props: IFrontTaskPanelProp) => {
    const isMounted = React.useRef(false);

    const [state, setState] = React.useState<FrontTaskPanelState>({
        toDoItems: null,
        isLoading: true
    });

    const loadRecordStatistics = async () => {
        setState((old) => ({ ...old, isLoading: true }));
        const toDoItems = await AppUtils.callService(() => taskService.getTaskToDoItems(), false, true, () => {
            if (!isMounted.current) return;
            setState((old) => ({ ...old, isLoading: false }));
        });
        if (!toDoItems || !isMounted.current) return;
        setState((old) => ({ ...old, toDoItems }));
    };

    useEffect(() => {
        isMounted.current = true;

        if (!props.companyId || !props.id) return;
        if (props.id === TaskStatisticsPanelId) {
            loadRecordStatistics();
        }

        return () => { isMounted.current = false; };
    }, [props.companyId, props.id]);

    if (props.id === TaskStatisticsPanelId) {
        return <DashboardStatistics
            loading={state.isLoading}
            title={TaskPagePanel.getPanelTitle(props.id)}
            toDoItems={state.toDoItems}
            onClick={(item) => handleFrontTaskPanelToDoItemClick(item, props.sessionState)}
        />;
    }

    return null;
};